import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AssignmentComponent } from '@src/suite/common/components/assignments-list/assignment/assignment';
import { ListDropDownComponent } from '@src/suite/common/components/list-drop-down/list-drop-down';
import { StoryItemComponent } from '@src/suite/common/components/stories-list/story-item/story-item';
import { StTopicItemComponent } from '@src/suite/common/components/topic-item/st-topic-item.component';

import { BaseViewOptionsComponent } from '../base-view-options.component';

@Component({
    selector: 'st-playbook-view-options',
    imports: [
        AssignmentComponent,
        ListDropDownComponent,
        MatButton,
        MatButtonModule,
        MatButtonToggleModule,
        MatIcon,
        MatListModule,
        MatMenuModule,
        MatTooltipModule,
        StoryItemComponent,
        StTopicItemComponent,
    ],
    templateUrl: './playbook-view-options.component.html',
    styleUrl: './playbook-view-options.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-playbook-view-options',
    },
})
export class PlaybookViewOptionsComponent extends BaseViewOptionsComponent {}
